import { getStatus } from 'resfull/npgw/cms/site_status';
import { getProductGroupCapacity , getByProductGroupIdAndLimitKey} from 'resfull/npgw/cms/videoLib';
import store from 'store';
const state = {
    buyStatus: 0, //  网站包含的客户端 1 单pc 2 单mobile 3 pc和mobile
    Capacity:{},
    Total:0
};

const getters = {
    buyStatus: state => state.buyStatus,
};

const actions = {
    async getBuyStatus({ commit }) {
        var result = await getStatus();
        if (result.status == '200' && result.data) {
            let buyStatus;
            let res = result.data;
            if (res.status == 8) {
                buyStatus = 2; // 2 单mobile
            } else if (res.mobileStatus == 8) {
                buyStatus = 1; //  1 单pc
            } else {
                buyStatus = 3; //   3 pc和mobile
            }
            commit('SET_BUYSTATUS', buyStatus);
            console.log('buyStatus:', buyStatus);
        }
    },
    async getUsedCapacity({commit}){
        let result = await  getProductGroupCapacity();
        console.log(result,result.data,'result');
        let Capacity = {
            image : 0 ,
            file : 0 ,
            video : 0 
        };
        if (result.status == '200') {
            if (result.data.photoSum) {
                Capacity.image = result.data.photoSum?result.data.photoSum:0;
            }
            if (result.data.fileSum) {
                Capacity.file = result.data.fileSum?result.data.fileSum:0;
            }
            if (result.data.videoSum) {
                Capacity.video = result.data.videoSum?result.data.videoSum:0;
            }
        } else {
            this.$message.error('获取容量失败');
        }
        commit('SET_CAPACITY', Capacity);
    },
    async getUsedTotal({commit}){
        let result = await getByProductGroupIdAndLimitKey({
            limitKey:'app_capacity_limit_resource-lib',
            moduleCode:'bossService',
            productGroupId:store.state.numberPortal.tenantJson.productGroupId
        })
        console.log(result,'result');
        if(result.limitValue){
            commit('SET_TOTAL', result.limitValue);
        } else{
            this.$message.error('获取总容量失败');
        }
    }
};

const mutations = {
    SET_BUYSTATUS(state, buyStatus) {
        state.buyStatus = buyStatus;
    },
    SET_CAPACITY(state, Capacity){
        state.Capacity = Capacity;
    },
    SET_TOTAL(state, Total){
        state.Total = Total;
    }
};

export default {
    state,
    actions,
    getters,
    mutations,
};
